var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alignLeft"},[_c('content-header',{attrs:{"sub-title":"","title":"बजार सम्बंदित लेखहरु","img-url":_vm.headerBackgroundUrl}}),_c('news-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }